import {
    CameraImageModel,
    CameraModel,
    IFrameIntegrationModel,
    IiFrameIntegrationModel,
    ProjectModel,
} from 'api/models';
import { getApiUrl } from 'config/api-url';
import http from 'config/http';

/* -------------------------------------------------------------------------------------------------
 * Get Integration Viewer
 * -----------------------------------------------------------------------------------------------*/
// export const getAutodeskIntegrationViewerDetails = async (token: string) => {
//     const { data } = await http.get(`${getApiUrl()}/autodesk-integration`, { params: { token } });

//     return {
//         camera: CameraModel.fromObject(data.camera),
//         project: ProjectModel.fromObject(data.project),
//         integration: AutodeskIntegrationModel.fromObject(data.integration),
//     };
// };

/* -------------------------------------------------------------------------------------------------
 * Get Integration Images
 * -----------------------------------------------------------------------------------------------*/
// export const getAutodeskIntegrationViewerImages = async (token: string, date?: string) => {
//     const { data } = await http.get(`${getApiUrl()}/autodesk-integration/images`, {
//         params: { token, date: date ? date : undefined },
//     });

//     const result = {
//         startDate: data.startDate as string,
//         endDate: data.endDate as string,
//         images: CameraImageModel.fromObjectList(data.images),
//     };

//     return result;
// };

/* -------------------------------------------------------------------------------------------------
 * Get IFrame Integration
 * -----------------------------------------------------------------------------------------------*/
export const getIFrameIntegration = async (projectId: string, cameraId: string) => {
    try {
        const { data } = await http.get(`${getApiUrl()}/projects/${projectId}/cameras/${cameraId}/integrations/iframe`);

        return IFrameIntegrationModel.fromObject(data);
    } catch (err) {
        console.log(err);
        return null;
    }
};

/* -------------------------------------------------------------------------------------------------
 * Update IFrame Integration
 * -----------------------------------------------------------------------------------------------*/
export const updateIFrameIntegration = async (
    projectId: string,
    cameraId: string,
    payload: Pick<IiFrameIntegrationModel, 'type' | 'options' | 'refreshInterval'>
) => {
    const { data } = await http.post(`${getApiUrl()}/projects/${projectId}/cameras/${cameraId}/integrations/iframe`, {
        integrationType: payload.type,
        options: payload.options,
        refreshInterval: payload.refreshInterval,
    });

    return IFrameIntegrationModel.fromObject(data);
};

/* -------------------------------------------------------------------------------------------------
 * Remove IFrame Integration
 * -----------------------------------------------------------------------------------------------*/
export const deleteIFrameIntegration = async (projectId: string, cameraId: string, integrationId: string) => {
    await http.delete(`${getApiUrl()}/projects/${projectId}/cameras/${cameraId}/integrations/iframe/${integrationId}`);
};

/* -------------------------------------------------------------------------------------------------
 * Get Integration Viewer
 * -----------------------------------------------------------------------------------------------*/
export const getIFrameIntegrationViewerDetails = async (token: string) => {
    const { data } = await http.get(`${getApiUrl()}/iframe-integration`, { params: { token } });

    return {
        camera: CameraModel.fromObject(data.camera),
        project: ProjectModel.fromObject(data.project),
        integration: IFrameIntegrationModel.fromObject(data.integration),
    };
};

/* -------------------------------------------------------------------------------------------------
 * Get Integration Images
 * -----------------------------------------------------------------------------------------------*/
export const getIFrameIntegrationViewerImages = async (token: string, date?: string) => {
    const { data } = await http.get(`${getApiUrl()}/iframe-integration/images`, {
        params: { token, date: date ? date : undefined },
    });

    const result = {
        startDate: data.startDate as string,
        endDate: data.endDate as string,
        images: CameraImageModel.fromObjectList(data.images),
    };

    return result;
};
